<div class="step-template" *ngIf="rootViewModel && rootViewModel.params.expenseModelData">
  <nts-expandable [title]="'ExpenseModelDataStep_Title'| NTSTranslate" [isCollapsed]="false" [disableToggle]="true"
    *ngIf="!this.rootViewModel.params.expenseModelData.existOnlyOneModel">

    <div class="state-container" *ngIf="rootViewModel.params.expenseModelData.showCurrentState">
      <div class="state-box">
        <div class="state-color"
          [style.backgroundColor]="rootViewModel.params.expenseModelData.expenseStateMapper.getColorByExpenseStateType(rootViewModel.params.expenseModelData.expenseState.value)">
          <div class="state-icon">
            <svg-icon
              [key]="rootViewModel.params.expenseModelData.expenseStateMapper.getIconByExpenseStateType(rootViewModel.params.expenseModelData.expenseState.value)">
            </svg-icon>
          </div>
        </div>
        <div class="state-label">{{rootViewModel.params.expenseModelData.expenseState.formattedValue}}</div>
      </div>
    </div>

    <div class="element-list">
      <nts-model-box *ngFor="let model of rootViewModel.params.expenseModelData.modelList" [model]="model"
        [selected]="model.identity['ModelCode'] === rootViewModel.params.expenseModelData?.expenseModelRef?.modelCode?.value"
        (onClicked)="selectModel($event)">
      </nts-model-box>

      <div *ngIf="!rootViewModel.params.expenseModelData.modelList.length" class="empty-message-container">
        <div class="empty-logo">
          <svg-icon [fontSize]="'50px'" [key]="'warning-circle-outline'"></svg-icon>
        </div>
        <div class="empty-message">
          {{'ExpenseModelDataStep_NoModelFoundMessage'| NTSTranslate}}
        </div>
      </div>
    </div>
  </nts-expandable>

  <nts-expandable [title]="rootViewModel.params.expenseData.files.metadataShortDescription" [isCollapsed]="false"
    [disableToggle]="true">



    <div class="edit-container">
      <nts-multiple-file-upload
        [showOnlyFirst]="true"
        [fileFilterCallBack]="isPrimarySectionFile.bind(this)"
        [singleFileMode]="true"
        [disableMoveFile]="true"
        [editable]="rootViewModel.params.expenseData.files.isEnabled"
        [isRemoteUploadEnabled]="this.rootViewModel.params.expenseModelData.isRemoteUpload"
        [moveDownCallBack]="rootViewModel.params.expenseData.files.moveDown.bind(rootViewModel.params.expenseData.files)"
        [moveUpCallBack]="rootViewModel.params.expenseData.files.moveUp.bind(rootViewModel.params.expenseData.files)"
        [files]="rootViewModel.params.expenseData.files"
        [removeCallBack]="rootViewModel.params.expenseData.files.removeFile.bind(rootViewModel.params.expenseData.files)"
        [viewFileCallBack]="viewExpenseFile.bind(this)"
        [addCallBack]="addPrimaryFile.bind(this)"
        [uploadCallBack]="this.receiptStepsService.orchestratorViewModel.uploadExpenseFile.bind(this.receiptStepsService.orchestratorViewModel)"
        (filesChanged)="fileUploadValidation()">
      </nts-multiple-file-upload>
    </div>

  </nts-expandable>

  <nts-fullscreen-preview [showNextPreviousButtons]="true" [showOnlyFirst]="true"
    (askNextImage)="rootViewModel.params.expenseData.showFullScreenNextImage(true, false)"
    (askPreviousImage)="rootViewModel.params.expenseData.showFullScreenPreviousImage(true, false)"
    [inIframe]="inIframe"
    [show]="true" [(imageSrc)]="rootViewModel.params.expenseData.currentImageModalSrc"
    [(imageBlob)]="rootViewModel.params.expenseData.currentImageModalBlob"
    [(imageName)]="rootViewModel.params.expenseData.currentImageModalName">
  </nts-fullscreen-preview>
</div>
